import axios from 'axios'

const service = axios.create({
  baseURL: '/web/api',
  timeout: 15000
})

// 获取完整图片URL
export function getImageUrl(path) {
  if (!path) return ''
  if (path.startsWith('http://') || path.startsWith('https://')) return path
  // /profile/ 路径加 /web 前缀
  if (path.startsWith('/profile/')) return '/web' + path
  return path
}

// 提取响应数据（兼容多种格式）
export function extractData(res, fallback) {
  if (!res) return fallback !== undefined ? fallback : null
  const d = res.data
  // 直接是数组
  if (Array.isArray(d)) return d
  // PageHelper分页对象：{total, pageNum, list/rows/records, ...}
  if (d && typeof d === 'object') {
    if (d.list) return d.list
    if (d.rows) return d.rows
    if (d.records) return d.records
    // 如果对象有数值索引键，提取为数组
    const keys = Object.keys(d).filter(k => /^\d+$/.test(k))
    if (keys.length > 0) return keys.sort((a,b) => +a - +b).map(k => d[k])
    return d
  }
  return fallback !== undefined ? fallback : []
}

// 提取分页总数
export function extractTotal(res) {
  if (!res) return 0
  if (res.total !== undefined) return res.total
  if (res.data && res.data.total !== undefined) return res.data.total
  if (res.data && res.data.length !== undefined) return res.data.length
  return 0
}

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 200) return res
    console.error('[API Error]', res.msg || '请求失败', response.config.url)
    return Promise.reject(new Error(res.msg || '请求失败'))
  },
  error => {
    console.error('[Network Error]', error.message, error.config && error.config.url)
    return Promise.reject(error)
  }
)

export default service
